import { BriefTimelinePopOver } from "@features/briefTimeline/BriefTimelinePopOver";
import {
  IBriefInfluencerV2,
  IInfluencerCostRequest,
} from "@shared/lib/types/briefInfluencerV2";
import { Button } from "@shared/ui/Button";
import { InputNumber } from "@shared/ui/InputNumber";
import { Flex, Form, Input, Space } from "antd";
import { useEffect } from "react";
import styles from "./styles.module.scss";
export function AddCommercials({
  initialValues,
  onClose,
  handleSave,
  isLoading,
  briefInfluencer,
  isViewOnly = false,
}: {
  initialValues: Partial<{
    cost: number;
    note: string;
  }>;

  onClose: () => void;
  handleSave: (
    values: Omit<IInfluencerCostRequest, "briefInfluencerId">
  ) => void;
  isLoading: boolean;
  briefInfluencer: IBriefInfluencerV2;
  isViewOnly?: boolean;
}) {
  const [form] = Form.useForm();

  const isPricingPocAssigned = Boolean(
    briefInfluencer?.assignedPricingPocV2?.assignedToUserId
  );

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);
  const cost = Form.useWatch("cost", form);

  return (
    <Form
      form={form}
      className={styles.commercialsForm}
      layout="vertical"
      onFinish={(values) => {
        handleSave(values);
      }}
      initialValues={initialValues}
      disabled={isViewOnly}
    >
      <Form.Item
        label={
          <Space>
            <BriefTimelinePopOver
              briefInfluencer={briefInfluencer}
              type="influencer"
            />
            Influencer Commercials
          </Space>
        }
        name="cost"
        rules={[{ required: true, message: "Please enter the  commercials" }]}
      >
        <InputNumber placeholder="100" style={{ width: "40%" }} />
      </Form.Item>
      <Form.Item label="Notes" name="note" rules={[{ required: false }]}>
        <Input placeholder="Enter special Notes about these commercials" />
      </Form.Item>

      <Flex justify="end" gap={4}>
        <Button onClick={onClose} disabled={false}>
          Back
        </Button>
        {!isViewOnly && (
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            disabled={!isPricingPocAssigned}
          >
            Save
          </Button>
        )}
      </Flex>
    </Form>
  );
}
